import { Contact } from '@salesforce/scv-connector-base';

export class ContactGenerator {
  static generate(phoneNumber: string): Contact {
    return new Contact({
      phoneNumber,
    });
  }
}
